import { toast } from "sonner";
import { api, coachHeaders } from "../lib/api";

const OPTIONS = [["", "Transport ?"], ["direct", "Direct"], ["sans_voiture", "Club · sans voiture"], ...[0, 1, 2, 3, 4, 5, 6].map((n) => [`p${n}`, n === 0 ? "Club · voiture pleine" : `Club · ${n} place${n > 1 ? "s" : ""}`])];

const valueOf = (r) => (r.transport === "direct" || r.transport === "sans_voiture" ? r.transport : r.transport === "places" ? `p${r.places ?? 0}` : "");
export const TRANSPORT_COLORS = {
  direct: "border-emerald-400 bg-emerald-400/15 text-emerald-300",
  places: "border-sky-400 bg-sky-400/15 text-sky-300",
  sans_voiture: "border-orange-400 bg-orange-400/15 text-orange-300",
};

export const ResponseRowActions = ({ r, code, convocationId, onChange }) => {
  const setStatut = async () => {
    const statut = r.statut === "present" ? "absent" : "present";
    if (!window.confirm(`Passer ${r.prenom} en ${statut === "present" ? "Présent" : "Absent"} ?`)) return;
    try {
      await api.put("/coach/reponses", { nom: r.nom, prenom: r.prenom, statut, convocation_id: convocationId }, coachHeaders(code));
      toast.success(`${r.prenom} : ${statut === "present" ? "Présent" : "Absent"}`);
      onChange();
    } catch { toast.error("Modification impossible"); }
  };
  const setTransport = async (v) => {
    if (!v) return;
    const body = v === "sans_voiture" || v === "direct" ? { transport: v } : { transport: "places", places: Number(v.slice(1)) };
    try {
      await api.put(`/reponses/${r.id}/transport`, body, coachHeaders(code));
      toast.success(`Transport de ${r.prenom} modifié`);
      onChange();
    } catch { toast.error("Modification impossible"); }
  };
  return (
    <>
      {r.statut === "present" && (
        <select data-testid={`coach-transport-select-${r.id}`} value={valueOf(r)} onChange={(e) => setTransport(e.target.value)} aria-label="Transport"
          className={`rounded-full border px-2 py-1 font-mono text-[11px] uppercase outline-none ${TRANSPORT_COLORS[r.transport] ?? "border-line bg-ink text-dim"}`}>
          {OPTIONS.map(([v, l]) => <option key={v} value={v} disabled={!v} className="bg-ink text-chalk">{l}</option>)}
        </select>
      )}
      <button data-testid={`coach-statut-toggle-${r.id}`} onClick={setStatut} title="Cliquer pour changer le statut"
        className={`rounded-full px-3 py-1 font-mono text-xs uppercase text-ink transition-opacity hover:opacity-80 ${r.statut === "present" ? "bg-lime" : "bg-signal"}`}>
        {r.statut === "present" ? "Présent" : "Absent"} ⇄
      </button>
    </>
  );
};


// Joueur sans réponse : le staff peut l'indiquer Présent ou Absent à sa place.
export const NoResponseActions = ({ j, code, convocationId, onChange }) => {
  const setStatut = async (statut) => {
    try {
      await api.put("/coach/reponses", { nom: j.nom, prenom: j.prenom, statut, convocation_id: convocationId }, coachHeaders(code));
      toast.success(`${j.prenom} : ${statut === "present" ? "Présent" : "Absent"}`);
      onChange();
    } catch { toast.error("Modification impossible"); }
  };
  return (
    <div className="flex shrink-0 gap-1.5">
      <button data-testid={`no-response-present-${j.id}`} onClick={() => setStatut("present")} className="rounded-full border border-lime px-3 py-1 font-mono text-xs uppercase text-lime transition-colors hover:bg-lime hover:text-ink">Présent</button>
      <button data-testid={`no-response-absent-${j.id}`} onClick={() => setStatut("absent")} className="rounded-full border border-signal px-3 py-1 font-mono text-xs uppercase text-signal transition-colors hover:bg-signal hover:text-ink">Absent</button>
    </div>
  );
};
